var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-checkbox',{staticClass:"table-multiple-select",attrs:{"hide-details":"","value":_vm.selected},nativeOn:{"!click":function($event){$event.stopPropagation();return _vm.onClick($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }